export const svgIconsList = [
  "edit",
  "delete",
  "date",
  "classes",
  "subject",
  "class_number",
  "course",
  "added",
  "completed",
  "badges",
  "exercise",
  "quiz",
  "homework",
  "open",
  "open_green",
  "points_active",
  "points_inactive",
  "certificate",
  "certificate_active",
  "certificate_inactive",
  "project",
  "pause_disabled",
  "class_done",
  "class_remaining",
  "class_number",
  "subject",
  "diagonal_arrow",
  "class_done",
  "class_remaining",
  "pause_class_active",
  "pause_class_inactive",
  "no_classes",
  "calendar",
  "pause_btn",
  "pause_icon_monitor",
  "circular_plus",
  "edit_btn",
  "cross",
  "tick",
  "settings",
  "circle_with_dot",
  "compeleted_tick_mark",
  "home",
  "resource",
  "community",
  "referral",
  "profile",
  "referral_active",
  "referral_inactive",
  "loop",
  "trash",
  "sunrise",
  "sun",
  "sunset",
  "pause_play_button",
];
